import {
  basicCoverage,
  prefferedCoverage,
  classicCoverage,
  superiorCoverage,
  limitedPowertrain,
  superiorWrapCoverage,
  oneThousandTwoHundredFifty,
  twoThousandFiveHundred,
  fiveThousand,
  sevenThousandFiveHundred,
  tenThousand,
  fiveHundred,
  sevenHundredFifty,
  powertrain3,
  powertrain5,
} from "@modules/purchase/warranty/types/ExtendedWarrantyCoverageType";
import { gapCO } from "./GapCoverageType";
import { IACoverageType } from "./IACoverageType";

export type IAProgram = {
  id: string;
  name: string;
  coverageTypes: IACoverageType[];
};

export const ExtendedWarrantyPremiumAutoCanadaDigital: IAProgram = {
  id: "AU190",
  name: "Premium",
  coverageTypes: [
    basicCoverage,
    prefferedCoverage,
    classicCoverage,
    superiorCoverage,
    superiorWrapCoverage,
  ],
};

export const ExtendedWarrantyEssentialHMAutoCanadaDigital: IAProgram = {
  id: "AU193",
  name: "Essential HM",
  coverageTypes: [limitedPowertrain, powertrain3, powertrain5],
};

export const ExtendedWarrantyEssentialVAAutoCanadaDigital: IAProgram = {
  id: "AU194",
  name: "Essential VA",
  coverageTypes: [limitedPowertrain, powertrain3, powertrain5],
};

export const ExtendedWarrantyAmaAutoCanadaDigital: IAProgram = {
  id: "AU192",
  name: "AMA",
  coverageTypes: [
    fiveHundred,
    sevenHundredFifty,
    oneThousandTwoHundredFifty,
    twoThousandFiveHundred,
    fiveThousand,
    sevenThousandFiveHundred,
    tenThousand,
  ],
};

export const GapAutoCanadaDigital: IAProgram = {
  id: "GP005",
  name: "GAP Plus",
  coverageTypes: [gapCO],
};

export const IAGapPrograms: IAProgram[] = [GapAutoCanadaDigital];

export const IAExtendedWarrantyPrograms: IAProgram[] = [
  ExtendedWarrantyPremiumAutoCanadaDigital,
  ExtendedWarrantyEssentialHMAutoCanadaDigital,
  ExtendedWarrantyEssentialVAAutoCanadaDigital,
  ExtendedWarrantyAmaAutoCanadaDigital,
];

export const getIAProgramById = (id: string): IAProgram | undefined => {
  return IAExtendedWarrantyPrograms.find((program) => program.id === id);
};
